import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  del,
  formDataPost,
  formDataPut,
  patch,
  post,
  put,
  get,
  pdfDownload,
} from "helpers/api_helper"
import {
  BRANCH_COUNTRY,
  COMMON_DATA,
  EXPORT_DATA,
  EXPORT_REQUEST,
  USER_ACTIVITY,
  USER_ACTIVITY_DETAILS,
} from "helpers/url_helper"

export const getUserActivity = createAsyncThunk(
  USER_ACTIVITY,
  async payload => {
    const response = await post(USER_ACTIVITY, payload)
    return response
  }
)

export const getUserActivityDetails = createAsyncThunk(
  USER_ACTIVITY_DETAILS,
  async payload => {
    const response = await post(USER_ACTIVITY_DETAILS, payload)
    return response
  }
)

export const exportData = createAsyncThunk(EXPORT_DATA, async payload => {
  const response = await pdfDownload(EXPORT_DATA, payload)
  return response
})

export const exportRequest = createAsyncThunk(EXPORT_REQUEST, async payload => {
  const response = await post(EXPORT_REQUEST, payload)
  return response
})

export const getBranchCountryList = createAsyncThunk(
  BRANCH_COUNTRY,
  async payload => {
    const response = await get(BRANCH_COUNTRY)
    return response
  }
)

export const getCountriesFromCommonData = createAsyncThunk(
  "COUNTRIES_COMMON",
  async () => {
    const response = await post(COMMON_DATA, { type: "Country" })
    return response
  }
)

export const getBrandsFromCommonData = createAsyncThunk(
  "BRANDS_COMMON",
  async () => {
    const response = await post(COMMON_DATA, { type: "Brand" })
    return response
  }
)

